import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import React, { useContext } from "react";
import { BsInfoCircleFill } from "react-icons/bs";
import { MdCheck, MdFileCopy, MdHighlightOff, MdInfoOutline } from "react-icons/md";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";
import { CP_PANEL_STYLES } from "./infoModal";
import { ClientContext } from "ClientProvider";
 
const InfoModalNew = ({ info, varient }: { info?: any; varient?: string }) => {
  const { singleRoleData } = useContext(ClientContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [copyPayment, setCopyPayment] = React.useState(false);
  const [copyRefund, setCopyRefund] = React.useState(false);
  const [copyGateway, setCopyGateway] = React.useState(false);

  const canViewPayment = singleRoleData?.[0]?.crypto?.value?.view_crypto_payout_response_information;
  const canViewGateway = singleRoleData?.[0]?.crypto?.value?.view_crypto_payout_gateway_response_information;

  const getDefaultTab = () => {
    if (canViewPayment) return "payment";
    if (canViewGateway) return "gateway";
    return "";
  };
  const [activeTab, setActiveTab] = React.useState(getDefaultTab);
  const [isCloseModal, setIsCloseModal] = React.useState(false);
  const [popoverOpen, setPopoverOpen] = React.useState(false);

  const handleClose = () => {
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };
  const copy = (data: any, setter: (v: boolean) => void) => {
    navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    setter(true); setTimeout(() => setter(false), 1500);
  };

  const TABS = [
    canViewPayment && {
      id: "payment",
      label: "Payment Response",
      dotColor: "blue",
      icon: (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="1" y="4" width="22" height="16" rx="2" />
          <line x1="1" y1="10" x2="23" y2="10" />
        </svg>
      ),
    },
    canViewGateway && {
      id: "gateway",
      label: "Gateway Response",
      dotColor: "purple",
      icon: (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>
      ),
    },
  ].filter(Boolean);

  const JsonBlock = ({ label, dotColor, data, copied, onCopy }: any) => (
    <div className="cp-json-section">
      <div className="cp-json-header">
        <div className="cp-json-label">
          <div className={`cp-json-dot cp-json-dot--${dotColor}`} />
          {label}
        </div>
        <button className={`cp-copy-btn${copied ? " cp-copy-btn--copied" : ""}`} onClick={onCopy}>
          {copied ? <><MdCheck size={13} />Copied!</> : <><MdFileCopy size={13} />Copy</>}
        </button>
      </div>
      <div className="cp-json-wrap">
        <pre className="cp-json-pre">{JSON.stringify(data, null, 2)}</pre>
      </div>
    </div>
  );

  return (
    <>
      <Popover trigger="hover" placement="bottom" closeOnBlur  closeOnEsc isOpen={popoverOpen && !isOpen} onOpen={() => setPopoverOpen(true)} onClose={() => setPopoverOpen(false)}>
        <PopoverTrigger>
          <button
            className="cp-info-trigger"
            onClick={() => { setActiveTab(getDefaultTab()); onOpen(); }}
            disabled={!info}
            aria-label="View payout info"
            onMouseEnter={() => !isOpen && setPopoverOpen(true)} onMouseLeave={() => setPopoverOpen(false)}
          >
            <MdInfoOutline size={14} />
          </button>
        </PopoverTrigger>
        <PopoverContent border="1px solid #ddd6fe" borderRadius="12px" bg="#faf5ff" maxW="220px" p="0" overflow="hidden" zIndex="20">
          <PopoverHeader bg="#ede9fe" fontSize="12px" fontWeight="700" color="#6d28d9" borderBottom="1px solid #ddd6fe" px="14px" py="10px">
            View Payout Information
          </PopoverHeader>
          <PopoverArrow bg="#faf5ff" />
        </PopoverContent>
      </Popover>

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
        <div className={`cp-panel${isOpen && !isCloseModal ? " cp-panel--open" : " cp-panel--close"}`}>
          <div className="cp-panel-glow" />

          <div className="cp-panel-header">
            <div className="cp-panel-brand">
              <div className="cp-panel-logo">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </div>
              <div>
                <h2 className="cp-panel-title">Crypto Payout Info</h2>
                <p className="cp-panel-sub">Payment &amp; gateway response details</p>
              </div>
            </div>
            <button className="cp-panel-close" onClick={handleClose}><MdHighlightOff size={22} /></button>
          </div>

          <div className="cp-tab-bar">
            {TABS.map((t) => (
              <button key={t.id} className={`cp-tab${activeTab === t.id ? " cp-tab--active" : ""}`} onClick={() => setActiveTab(t.id)}>
                {t.icon}{t.label}
              </button>
            ))}
          </div>

          <div className="cp-panel-body">
            {activeTab === "payment" && canViewPayment && (
              <>
                <JsonBlock label="Payment Response" dotColor="blue" data={info?.meta_info} copied={copyPayment} onCopy={() => copy(info?.meta_info, setCopyPayment)} />
                {info?.refund_info && (
                  <JsonBlock label="Refund Info" dotColor="purple" data={info?.refund_info} copied={copyRefund} onCopy={() => copy(info?.refund_info, setCopyRefund)} />
                )}
              </>
            )}
            {activeTab === "gateway" && canViewGateway && (
              <JsonBlock label="Gateway Response" dotColor="purple" data={info?.gateway_response} copied={copyGateway} onCopy={() => copy(info?.gateway_response, setCopyGateway)} />
            )}
          </div>

          <div className="cp-panel-footer">
            <div className="cp-footer-note">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              Read-only payout data
            </div>
            <button className="cp-btn-close" onClick={handleClose}>Close</button>
          </div>
        </div>
      </Modal>

      {CP_PANEL_STYLES}
    </>
  );
};

export default InfoModalNew;